import { unwrapXmlStyleContent } from './apiFieldText';
/**
 * Flow Builder rows carry a `SYSTEM_STATUS` column; `I` marks the record inactive.
 * Inactive records must never reach this public portal, so grid ingestion drops them
 * before mapping (list, search catalog and any counts derived from them).
 */
const SYSTEM_STATUS_KEY = 'systemstatus';
const INACTIVE_STATUS = 'I';
/** `SYSTEM_STATUS`, `System_Status`, `systemStatus`, … all normalize to `systemstatus`. */
function normalizeKey(key) {
    return key.toLowerCase().replace(/[^a-z0-9]/g, '');
}
/** Raw `SYSTEM_STATUS` cell as plain text (grid cells are sometimes pseudo-XML, e.g. `<SYSTEM_STATUS>I</SYSTEM_STATUS>`). */
export function readSystemStatus(row) {
    if (!row || typeof row !== 'object')
        return '';
    for (const [k, v] of Object.entries(row)) {
        if (normalizeKey(k) !== SYSTEM_STATUS_KEY)
            continue;
        if (typeof v !== 'string')
            continue;
        const t = unwrapXmlStyleContent(v).trim();
        if (t)
            return t;
    }
    return '';
}
/**
 * True only when the row explicitly says `I`. Rows without the column (or with any other
 * status) stay visible — a missing column must not blank out the whole list.
 */
export function isInactiveSystemStatusRow(row) {
    return readSystemStatus(row).toUpperCase() === INACTIVE_STATUS;
}
